<template>
    <Chart
        card
        class="mt-3"
        :height="400"
        :series="[]"
        :options="chartOptions"
        :header="$t('traffic')"
        :error="requestChart.getError()"
        :loading="requestChart.getLoading()"
        :range="groupBy"
    >
        <template #nav>
            <MultiselectAvailableCampaigns v-model="campaigns" :disabled="requestChart.getLoading()" @change="fetchChart()" />
        </template>
    </Chart>
</template>



<script>
    import { chartDataGroupBy, generateChartData } from '@/utils/chart';
    import cloneDeep from 'lodash/cloneDeep';
    import Chart from '@/components/common/Chart.vue';
    import MultiselectAvailableCampaigns from '@/components/common/MultiselectAvailableCampaigns.vue';

    export default {
        name: 'TrafficChart',
        components: {
            Chart,
            MultiselectAvailableCampaigns,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestChart: this.parentComponent.requestTrafficChart,
                requestCampaigns: this.$req('buyboxes/AvailableCampaigns'),
                campaigns: [],
            };
        },
        computed: {
            item() {
                return this.parentComponent.item;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                return {
                    urlParams: {
                        id: this.item.id,
                    },
                    requestParams: {
                        ...(this.timeRange || {}),
                        groupBy: this.groupBy,
                    },
                };
            },
            groupBy() {
                return chartDataGroupBy(this.timeRange);
            },
            chartData() {
                return this.requestChart.getData() || [];
            },
            chartOptions() {
                const chartData = this.chartData.reduce(
                    (acc, item) => {
                        acc.impressions.push([item.date, item.impressions]);
                        acc.clicks.push([item.date, item.clicks]);
                        return acc;
                    },
                    { impressions: [], clicks: [] }
                );
                return {
                    series: [
                        {
                            name: this.$t('clicks'),
                            type: 'line',
                            data: generateChartData(this.parentComponent.timeRange, chartData.clicks, this.groupBy),
                        },
                        {
                            name: this.$t('offersDisplay'),
                            type: 'bar',
                            data: generateChartData(this.parentComponent.timeRange, chartData.impressions, this.groupBy),
                        },
                    ],
                    yaxis: [
                        {
                            title: {
                                text: this.$t('clicks'),
                            },
                        },
                        {
                            opposite: true,
                            title: {
                                text: this.$t('offersDisplay'),
                            },
                        },
                    ],
                };
            },
        },
        watch: {
            item: {
                immediate: true,
                handler: 'loadData',
            },
            timeRange: {
                immediate: false,
                handler: 'loadData',
            },
        },
        methods: {
            loadData() {
                this.fetchChart();
            },
            fetchChart(params = { cache: false }) {
                const apiParams = cloneDeep(this.apiParams);
                if (this.campaigns?.length) apiParams.requestParams.campaigns = this.campaigns.map(item => item.id).join(',');
                this.requestChart.get({ ...apiParams, ...params });
            },
            fetchCampaigns() {
                const id = this.$store.getters['plugin/getProducerPlugin'].id;
                return this.requestCampaigns.get({ urlParams: { id, v: 1 } });
            },
        },
    };
</script>
